$(function(){
  // 1回目のアクセス
  if($.cookie("access") == undefined) {
    //最初にアクセスしたときにはここに書いたアニメーションのJSが動く
    $.cookie("access","onece");
    $("#load").css("display","block")
  // 2回目以降は動かないようにするけど最初は動かす
  } else {
$("#load").css("display","none")
    // 2回目以降は動かないようにする
  }
});